/**
* @Description: VIP_INTRODUCE
* @author XuZiYu
* @date 2021/12/08 10:02:27
* @update 2022/08/30 ZhanFuzheng 获取车型方式调整
*/
<template>
  <div class="wrapper-open">

    <!--头部-->
    <template v-if="!H5 && headVisible !== '0'">
      <div class="header">
        <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
        <div class="header-main">VIP题库8大权益</div>
        <div class="header-share" v-if="shareVisible" @click="openSharePanel">
          <img src="@/assets/public/icon_fx01.png" alt=""></div>
        <div class="header-right" v-if="!H5" @click="callPhone">
          <img src="@/assets/vip/icon_customerservice1.png" alt=""></div>
      </div>

      <!--头部占位-->
      <div class="header-pre"></div>
    </template>

    <!--分享框架-->
    <share-ad :detail="shareData">
      <swiper class="swiper" ref="swiper" :options="swiper">
        <swiper-slide><img class="item-img" src="@/assets/vip/picture_jx500.png" alt=""></swiper-slide>
        <swiper-slide><img class="item-img" src="@/assets/vip/picture_yctgg.png" alt=""></swiper-slide>
        <swiper-slide><img class="item-img" src="@/assets/vip/picture_zsdsj.png" alt=""></swiper-slide>
        <swiper-slide><img class="item-img" src="@/assets/vip/picture_kqtj.png" alt=""></swiper-slide>
        <swiper-slide><img class="item-img" src="@/assets/vip/picture_kqmj.png" alt=""></swiper-slide>
        <swiper-slide><img class="item-img" src="@/assets/vip/picture_znks.png" alt=""></swiper-slide>
        <swiper-slide><img class="item-img" src="@/assets/vip/picture_yctgl.png" alt=""></swiper-slide>
        <swiper-slide><img class="item-img" src="@/assets/vip/picture_kcmn.png" alt=""></swiper-slide>
      </swiper>

      <div class="paging" ref="paging">
        <div class="item" :class="['item', swiperIndex === '0' && 'active']" @click="changeSwiperIndex(0)">
          <img class="item-img" src="@/assets/vip/icon_jx500_01.png" alt="">
          <div class="item-name">精选500题</div>
        </div>
        <div class="item" :class="['item', swiperIndex === '1' && 'active']" @click="changeSwiperIndex(1)">
          <img class="item-img" src="@/assets/vip/icon_yctgg_01.png" alt="">
          <div class="item-name">易错题巩固</div>
        </div>
        <div class="item" :class="['item', swiperIndex === '2' && 'active']" @click="changeSwiperIndex(2)">
          <img class="item-img" src="@/assets/vip/icon_zsdsj_01.png" alt="">
          <div class="item-name">知识点速记</div>
        </div>
        <div class="item" :class="['item', swiperIndex === '3' && 'active']" @click="changeSwiperIndex(3)">
          <img class="item-img" src="@/assets/vip/icon_kqtj_01.png" alt="">
          <div class="item-name">考前突击</div>
        </div>
        <div class="item" :class="['item', swiperIndex === '4' && 'active']" @click="changeSwiperIndex(4)">
          <img class="item-img" src="@/assets/vip/icon_kqmj_01.png" alt="">
          <div class="item-name">考前秘卷</div>
        </div>
        <div class="item" :class="['item', swiperIndex === '5' && 'active']" @click="changeSwiperIndex(5)">
          <img class="item-img" src="@/assets/vip/icon_znks_01.png" alt="">
          <div class="item-name">智能考试</div>
        </div>
        <div class="item" :class="['item', swiperIndex === '6' && 'active']" @click="changeSwiperIndex(6)">
          <img class="item-img" src="@/assets/vip/icon_yctgl_01.png" alt="">
          <div class="item-name">预测通过率</div>
        </div>
        <div class="item" :class="['item', swiperIndex === '7' && 'active']" @click="changeSwiperIndex(7)">
          <img class="item-img" src="@/assets/vip/icon_kcmn_01.png" alt="">
          <div class="item-name">考场模拟</div>
        </div>
      </div>

    </share-ad>

    <!--消息弹出框-->
    <ctl-dialog v-model="messageDialog" :loading="loading"/>
  </div>
</template>

<script>
import dialog from '@/components/dialog/index.vue'
import { Toast, Button } from 'vant'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    name: 'vipIntroduce',
    components: {
        ctlDialog: dialog,
        [Button.name]: Button,
        Swiper,
        SwiperSlide
    },
    methods: {
    // 切换轮播
        changeSwiperIndex (v) {
            this.$refs.swiper.$swiper.slideTo(v, 200)
        },
        // 返回
        goBack () {
            if (this.$route.query.webview === '0') {
                this.$router.back()
            } else {
                this.$jsBridge.callBackHandler('returnLastPage')
            }
        },
        // 拨打客服电话
        callPhone () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || 'VIP题库'
            // 内容
            let content = '掌握一题=练习多题，轻松搞定科一&科四！'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'question-bank'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}&cityCode=${this.cityCode}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/VIPtk.png'
            }

            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: 'question-bank' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result

                    // app进入对应权益
                    if (this.$route.query.type) {
                        this.$nextTick(() => {
                            this.changeSwiperIndex(Number(this.$route.query.type) - 1)
                        })
                    }
                }
            })
        },
        // 检查车型
        checkCarType () {
            const carTypeName = this.$store.getters.carTypeName

            if (Number(this.carType) !== 1) {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '切换题库',
                    leftBtnName: '我知道了',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false

                        // 进入设置题库页面
                        this.$jsBridge.callBackHandler('pushQuestionBankSettingPage')
                    },
                    title: '温馨提示',
                    content: `该服务现仅适用于小车学员，您当前车型-${carTypeName[this.carType]}，是否需切换回小车题库？`
                }
            }
        },
        // 初始化
        init () {
            // 底部按钮字体布局兼容
            if (this.IOS && this.openData.payConPoint) {
                this.$nextTick(() => {
                    document.querySelectorAll('.top')[0].style.fontSize = '15px'
                    document.querySelectorAll('.bottom')[0].style.fontSize = '14px'
                })
            }

            // 获取用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // app埋点
            this.$jsBridge.callBackHandler('onEventObjectUM', {
                eventId: 'e_ervip_detail_visit',
                map: JSON.stringify({ subject: 3 })
            })

            // 设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'

            // 设置城市code
            this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

            // 设置版本
            this.version = this.$jsBridge.callBackHandler('getAppVersion') || ''

            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 设置分享显示
            this.shareVisible = !this.H5

            // 设置头部显示
            this.headVisible = this.$route.query.headShow || '1'

            // 暴露支付回调方法
            this.$jsBridge.registerHandler('payCallback', this.payCallback)

            // 暴露分享回调方法
            this.$jsBridge.registerHandler('shareCallback', this.shareCallback)

            // 暴露刷新页面方法
            this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)
        },
        // 获取vip数据
        getVipData () {
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.getVipMatchEntryV3({
                version: this.version,
                cityCode: this.cityCode,
                appType: this.appType
            }).then(res => {
                Toast.clear()
                if (res.status) {
                    // 设置vip数据
                    this.vipData = res.result

                    // 开通跳转已开通
                    if (this.vipData.vipFlag) {
                        this.goVip()
                    }

                    // 设置vip开通数据
                    this.openData = JSON.parse(JSON.stringify(this.vipData.examVipSettingDTO))
                } else {
                    Toast.fail(res.message)
                }
            })
        },
        // 跳转vip题库
        goVip () {
            this.$router.replace({
                name: 'vipV3',
                query: this.$route.query
            })
        },
        // 刷新数据
        refreshCallBack () {
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 重新获取app token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')

            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }

            // 重新设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 重新设置城市code
            this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

            // 刷新vip数据
            this.getVipData()
        }
    },
    mounted () {
        this.init()

        this.getVipData()

        this.checkCarType()
    },
    created () {
        this.getSetting()
    },
    data () {
        let _this = this
        return {
            // 轮播数据
            swiper: {
                slidesPerView: 1.25,
                centeredSlides: true,
                on: {
                    slideChangeTransitionEnd: function () {
                        _this.swiperIndex = String(this.activeIndex)
                        if (_this.swiperIndex >= 4) {
                            _this.$refs.paging.scrollLeft = 500
                        } else {
                            _this.$refs.paging.scrollLeft = 0
                        }
                    }
                }
            },
            // 轮播index
            swiperIndex: '0',
            // vip数据
            vipData: {},
            // 用户数据
            userInfo: {},
            // 车型默认小车
            carType: '1',
            // vip开通数据
            openData: {},
            // 分享数据
            shareData: {},
            // loading
            loading: false,
            // 显示分享
            shareVisible: false,
            // 头部显示
            headVisible: '',
            // app类型 1-定制版 2-学时版
            appType: '',
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // h5标记
            H5: false,
            // 弹窗数据
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper-open {
  background: #212528;

  .shareAd-wrap {
    overflow: hidden;
  }

  .swiper {
    margin-top: 60px;

    .swiper-slide {
      text-align: center;
      transform: translate3d(0, 0, 0);
      box-sizing: content-box;
      padding-bottom: 0.05rem;
      margin-top: -0.05rem;
    }

    .item-img {
      margin: 0 auto;
      width: 280px;
      min-height: 400px;
    }

    .swiper-slide-next, .swiper-slide-prev {
      opacity: 0.5;
    }
  }

  .paging {
    box-sizing: border-box;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    overflow: auto;
    padding-left: 20px;
    white-space: nowrap;
    margin-top: 60px;

    .item {
      margin-right: 15px;
      text-align: center;
      display: inline-block;
    }

    .item-img {
      width: 45px;
      opacity: 0.5;
    }

    .item-name {
      margin-top: 10px;
      font-size: 13px;
      font-weight: 400;
      color: #999999;
    }

    .item.active {
      .item-name {
        color: #FFE2B8;
      }

      .item-img {
        opacity: 1;
      }
    }
  }

  @media screen and (max-height: 720px) {
    .paging {
      position: static;
      margin: 15px 0 0 0;
    }
    .swiper {
      margin-top: 10px;
    }
  }

  .pay-course {
    font-weight: bold;
    margin: 0 10px 15px 0;
    text-decoration: underline;
    font-size: 13px;
    color: #FFFFFF;
    text-align: right;
    line-height: 1;
  }

  .van-button {
    height: 100%;
    border: none;
  }

  .van-button__loading {
    margin: 0 auto;
    vertical-align: middle;
  }

  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    background: #ffffff;

    .header-main {
      font-size: 18px;

      font-weight: bold;
      color: #333333;
    }

    .header-share {
      position: absolute;
      height: 60px;
      display: flex;
      align-items: center;
      right: 50px;
      font-size: 0;
      line-height: 1;

      img {
        width: 24px;
      }
    }

    .header-left, .header-right {
      display: flex;
      padding: 15px 10px;
      font-size: 0;
      line-height: 1;

      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .header-pre {
    height: 60px;
  }

  .bg {
    line-height: 1;
    font-size: 0;

    img {
      width: 375px;
    }
  }

  .footer-pre {
    height: 49px;
  }

  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1;
    height: 49px;
    border-top: 1px solid #EEEEEE;
    background: #ffffff;
    display: flex;
    justify-content: space-between;

    .buoy {
      width: 110px;
      top: -26px;
      left: 20px;
      position: absolute;
    }

    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .first {
      flex-direction: column;
      flex: 1;

      font-weight: 600;
      color: rgba(255, 80, 80, 1);

      .top {
        color: #FF5050;
        font-size: 18px;
      }

      .bottom {
        color: #999999;
        font-size: 14px;
        text-decoration: line-through;
      }
    }

    .second {
      flex: 1;
      font-size: 17px;

      font-weight: bold;
      color: #333333;

      b {
        font-size: 13px;
        font-weight: normal;
      }
    }

    .third {
      width: 80px;
      background: #FFEED2;
      font-size: 18px;

      font-weight: bold;
      color: #D4A36B;
    }

    .fourth {
      border-radius: 0;
      width: 110px;
      background: #F5DDB6;
      font-size: 17px;

      font-weight: bold;
      color: #A86F2F;
    }

    .recovery {
      border-radius: 0;
      width: 110px;
      background: #FFEED2;
      font-size: 17px;

      font-weight: bold;
      color: #A86F2F;
    }
  }

  .rule {
    margin: 10px auto 15px;
    width: 355px;
    background: #3B3E43;
    border-radius: 5px;
    padding-bottom: 20px;

    .rule-title {
      display: block;
      margin: 0 auto 20px;
      width: 120px;
      height: 30px;
    }

    .rule-item {
      padding: 0 15px;

      .rule-item-title {
        background: url("~@/assets/vip/icon_wt.png") no-repeat left 2px;
        background-size: 16px;

        padding-left: 26px;
        line-height: 22px;
        font-size: 15px;
        font-weight: 600;
        color: #FFFFFF;
      }

      .rule-item-content {
        word-break: break-word;
        white-space: pre-line;
        margin-top: 10px;
        padding-left: 26px;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 21px;

        b {
          color: #FF5050;
        }
      }
    }

    .rule-item + .rule-item {
      margin-top: 20px;
    }
  }

  .btn-none-buy {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    font-size: 15px;
    font-weight: bold;
    color: #999999;
    background: #F0F0F0;
  }

  .change-page {
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    width: 100%;
    bottom: 49px;
    background: #fff;

    .item {
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 170px;
      height: 45px;
      font-size: 15px;
      font-weight: 600;
      color: #FFFFFF;
      border-radius: 5px;
      background: #000000;
      border: 1px solid #000000;
    }

    .icon {
      position: absolute;
      right: -1px;
      top: -1px;
      width: 40px;
      height: 18px;
    }

    .item:nth-child(2) {
      background: #ffffff;
      border: 1px solid #C0C1C4;
      color: #6A220D;
    }
  }

  .change-page-pre {
    height: 60px;
  }
}
</style>
